'use client';
import { SessionProvider } from 'next-auth/react';

import Footer from '@/components/common/Footer';
import Navbar from '@/components/common/Navbar';

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div className="dark:text-white">
      <SessionProvider>
        <Navbar />
        {children}
        {/* <Newsletter /> */}
        <Footer />
      </SessionProvider>
    </div>
  );
}
